/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Group_CountInputs */

const en_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} group(s)`)
};

const fr_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} groupe(s)`)
};

const de_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gruppe(n)`)
};

const it_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} gruppo/i`)
};

const ru_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Группа(ы) ${i?.count}`)
};

const es_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} grupo(s)`)
};

const zh_cn2_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 组`)
};

const ja_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} グループ`)
};

const hi_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} समूह(ओं)`)
};

const pt_pt2_team_manager_group_count = /** @type {(inputs: Team_Manager_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grupo(s) ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{count} group(s)" |
*
* @param {Team_Manager_Group_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_count = /** @type {((inputs: Team_Manager_Group_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_count(inputs)
	if (locale === "de") return de_team_manager_group_count(inputs)
	if (locale === "it") return it_team_manager_group_count(inputs)
	if (locale === "ru") return ru_team_manager_group_count(inputs)
	if (locale === "es") return es_team_manager_group_count(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_count(inputs)
	if (locale === "ja") return ja_team_manager_group_count(inputs)
	if (locale === "hi") return hi_team_manager_group_count(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_count(inputs)
	return en_team_manager_group_count(inputs)
});